import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadReportTemplateByIdFailed, loadReportTemplateByIdSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadReportTemplateById(action) {
  try {
    const url = `${BACKEND_URL}/resources/report-templates/${action.payload}`;
    yield call(resolveActionPromise(action));
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadReportTemplateByIdSuccessful(data.data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadReportTemplateByIdFailed());
      yield call(rejectActionPromise(action));
    }
    yield put(loadReportTemplateByIdSuccessful({
      id: 1,
      data: 'Получение данных от ГИС ГМП о штрафах',
      service: 'SID0003998 Электронный сервис государственной информационной системы о государственных и муниципальных платежах',
      source: 'СМЭВ СПб',
      created_at: '2024-12-12',
      status: '1',
      procedures: ['1227.1', '1227.2', '1227.3'],
    }));
  } catch (e) {
    yield put(loadReportTemplateByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
